import { useNavigate } from "react-router-dom";

type TitelBarProps = {
    isCourseProgressPage?: boolean;
    setShowLesson?: (value: boolean) => void;
    isLessonPage?: boolean;
    title?: string;
    subTitle?: string;
    isBackTo?: boolean;
    backPath?: string;
    backState?: any | null;
    backToTitle?: string;
}

export const TitleBar = ({ isCourseProgressPage = false, setShowLesson, isLessonPage = false, title, subTitle, isBackTo = false, backPath = "", backState = null, backToTitle = "" }: TitelBarProps) => {
    const navigate = useNavigate();
    return (
        <div className={`w-full bg-[#FAFAFA] rounded-md p-4 ${isCourseProgressPage || isBackTo ? "flex justify-between items-center" : "block"}`}>
            <div
                className={`w-max ${isLessonPage ? "cursor-pointer hover:text-primary" : "cursor-default"} ${isCourseProgressPage ? "text-primary" : " text-black"}`}
                onClick={() => isLessonPage ? setShowLesson && setShowLesson(false) : null}
            >
                <span className="text-lg max-md:text-sm font-semibold">{title}</span><br />
                <span className="text-sm max-md:text-xs text-gray-500 font-medium">{subTitle}</span>
            </div>

            {
                isCourseProgressPage && (
                    <div
                        className="flex items-center gap-1.5 hover:text-primary cursor-pointer  text-gray-500"
                        onClick={() =>
                            setShowLesson && setShowLesson(true)
                        }
                    >
                        <span className="material-symbols-outlined text-lg max-md:text-sm">
                            chevron_left
                        </span>
                        <span className="text-sm font-medium max-md:text-xs">
                            Back to Lesson
                        </span>
                    </div>
                )
            }
            {
                (isBackTo && backPath && !isCourseProgressPage) && (
                    <div
                        className="flex items-center gap-1.5 hover:text-primary cursor-pointer  text-gray-500"
                        onClick={() => backState ? navigate(backPath, backState && { state: backState }) : navigate(backPath)}
                    >
                        <span className="material-symbols-outlined text-lg max-md:text-sm">
                            chevron_left
                        </span>
                        <span className="text-sm font-medium max-md:text-xs">
                            {backToTitle}
                        </span>
                    </div>
                )
            }
        </div>
    )
}